import { useAppStateStore } from '@/features/application'
import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
import type { NavigateToLocation } from '@/router/navigateTo/navigateTo.types.ts'
import router from '../index.ts'
import type { NavigateToLocationWithContext } from './navigateToMeta.ts'
import type { RouteLocationRaw } from 'vue-router'

function findRoute(location: NavigateToLocation) {
  const routes = router.getRoutes()
  return routes.find((route) => route.meta.navigateToHelper?.isRouteValid(location) ?? false)
}

function getCurrentContext() {
  const appState = useAppStateStore()
  if (appState.contextCourant === TypesContextesAutorisesEnum.Prestataire) return 'prestataire'
  else if (appState.contextCourant === TypesContextesAutorisesEnum.Adherent) return 'adherent'
}


export function navigateTo(location: NavigateToLocation, openInNewTab: boolean = false) {
  async function goTo(to: RouteLocationRaw) {
    if (openInNewTab) {
      const resolved = router.resolve(to)
      window.open(resolved.fullPath, '_blank')
    } else {
      await router.push(to)
    }
  }

  const locationWithContext: NavigateToLocationWithContext = {
    context: undefined,
    ...location,
  }
  if (locationWithContext.context === undefined)
    locationWithContext.context = getCurrentContext()

  const route = findRoute(locationWithContext)
  if (!route) {
    console.error(`navigateTo: route not found : ${JSON.stringify(locationWithContext)}`)
    return goTo({ name: 'NotFound' })
  }

  const routeOptions = route.meta.navigateToHelper?.locationToRoute(locationWithContext) ?? {}
  return goTo({
    name: route.name,
    ...routeOptions
  })
}
